import { Button, Modal } from "react-bootstrap";
import EyeIcon from "../Assets/Images/EyeIcon";
import GitIcon from "../Assets/Images/GitIcon";
import { CommonService } from "../CommonSearvice";

const ProjectDetailModal = (props) => {
  const { data } = props;

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          className="title-primary"
          id="contained-modal-title-vcenter"
        >
          {data.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <img
            className="project-img"
            src={CommonService.ProjectImage(data.subtitle)}
            alt={data.subtitle}
          />

          <div className="my-3">
            {data.technology.map((item) => (
              <span className="me-2" key={item}>
                {CommonService.TechIcon(item)}
              </span>
            ))}
          </div>

          <p className="project-detail body-text ">{data.detail}</p>
          <div className="project-btn d-flex justify-content-between">
            {data.sourcelink !== "" && (
              <a href={data.sourcelink} target="_blank" rel="noreferrer">
                <Button variant="main-btn gray-btn">
                  Source Code <span className="ms-2"> <GitIcon /></span>
                </Button>
              </a>
            )}
            {data.livelink !== "" && (
              <a href={data.livelink} target="_blank" rel="noreferrer">
                <Button variant="main-btn eye">
                  Live Project <span className="ms-2"> <EyeIcon /></span>
                </Button>
              </a>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProjectDetailModal;
